import '@updater-components/cta';
import { ITEM_STATUSES } from '../../../../constants/items';
import { IS_TOUCH_DEVICE } from '../../../../constants';
import { actions } from '../../../../state';
import template from './step.html';
import './step.global.css';
import '../marketing-icon';

const ELLIPSIS_MENU_ITEMS = [
  {
    id: 1,
    name: 'I already did this',
    value: ITEM_STATUSES.ALREADY_DONE,
    analyticsEvent: 'Clicked Already Done Status',
  },
  {
    id: 2,
    name: `I don't need this`,
    value: ITEM_STATUSES.NOT_NEEDED,
    analyticsEvent: 'Clicked Not Needed Status',
  },
];

const OPEN_STATUSES = [
  ITEM_STATUSES.NOT_STARTED,
  ITEM_STATUSES.STARTED,
  ITEM_STATUSES.CLAIMED,
];

class TimelineStepController {
  isTouchDevice = IS_TOUCH_DEVICE;

  constructor(updStore) {
    'ngInject';
    Object.assign(this, { updStore });
  }

  $onChanges({ step }) {
    if (step) {
      this.ellipsisMenuItems = ELLIPSIS_MENU_ITEMS.map(item => ({
        ...item,
        analyticsProperties: {
          Status: item.value,
          Code: step.currentValue.code,
        },
      }));
    }
  }

  get ctaLabel() {
    return this.showDetail
      ? this.step.status === ITEM_STATUSES.NOT_STARTED
        ? 'Start'
        : 'Continue'
      : 'Reopen Task';
  }

  get showDetail() {
    return OPEN_STATUSES.indexOf(this.step.status) !== -1;
  }

  handleCtaClick() {
    this.updStore.dispatch(
      actions.analytics.track('Clicked Step Card', { Code: this.step.code })
    );
    this.triggerChange(ITEM_STATUSES.STARTED);
  }

  triggerChange(value) {
    this.change({
      $value: {
        code: this.step.code,
        uiState: this.step.uiState,
        status: value,
      },
    });
  }

  handlePopupMenuItemChange(value) {
    const item = this.ellipsisMenuItems.find(item => item.value === value);
    if (item) {
      this.updStore.dispatch(
        actions.analytics.track(item.analyticsEvent, item.analyticsProperties)
      );
    }

    this.triggerChange(value);
  }

  handleEllipsisClick(event) {
    // Normally should not do this, but we only want the menu analytics to fire without
    // firing any analytics events above
    event.stopPropagation();
    this.updStore.dispatch(
      actions.analytics.track('Clicked Card Ellipses Menu', {
        Code: this.step.code,
      })
    );
  }
}

export const TimelineStepComponent = {
  controller: TimelineStepController,
  bindings: {
    step: '<',
    change: '&',
  },
  template,
};
